import "./navbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Navbar() {
    return (
        <div className="navbar-wrapper">
            <div className="navbar-container">
                <div className="navbar-logo-container">
                    <a href="https://crempreendimentos-sc.com/">
                        <img width="800" height="197" src="https://crempreendimentos-sc.com/wp-content/uploads/2023/04/logo-CR-EMPREENDIMENTOS-sem-slogan-branca-003-1024x252.png" className="attachment-large size-large wp-image-946" alt="" srcSet="https://crempreendimentos-sc.com/wp-content/uploads/2023/04/logo-CR-EMPREENDIMENTOS-sem-slogan-branca-003-1024x252.png 1024w, https://crempreendimentos-sc.com/wp-content/uploads/2023/04/logo-CR-EMPREENDIMENTOS-sem-slogan-branca-003-300x74.png 300w, https://crempreendimentos-sc.com/wp-content/uploads/2023/04/logo-CR-EMPREENDIMENTOS-sem-slogan-branca-003-768x189.png 768w, https://crempreendimentos-sc.com/wp-content/uploads/2023/04/logo-CR-EMPREENDIMENTOS-sem-slogan-branca-003-1536x377.png 1536w, https://crempreendimentos-sc.com/wp-content/uploads/2023/04/logo-CR-EMPREENDIMENTOS-sem-slogan-branca-003.png 1587w" sizes="(max-width: 800px) 100vw, 800px" />
                    </a>
                </div>

                <div className="elementor-widget-container">
                    <nav aria-label="Menu" className="elementor-nav-menu--main elementor-nav-menu__container elementor-nav-menu--layout-horizontal e--pointer-none">
                        <ul className="navbar-list">
                            <li className="navbar-item"><a href="https://crempreendimentos-sc.com/" aria-current="page" className="elementor-item elementor-item-active">HOME</a></li>
                            <li className="navbar-item"><a href="https://crempreendimentos-sc.com/quem-somos/" className="elementor-item">QUEM SOMOS</a></li>
                            <li className="navbar-item"><a href="https://crempreendimentos-sc.com/loteamentos/" className="elementor-item">LOTEAMENTOS</a></li>
                            <li className="navbar-item"><a href="https://crempreendimentos-sc.com/classificados/" className="elementor-item">CLASSIFICADOS</a></li>
                            <li className="navbar-item"><a href="https://crempreendimentos-sc.com/contato/" className="elementor-item">CONTATO</a></li>
                        </ul>
                    </nav>
                </div>

                <div className="navbar-buttons">
                    <a href="https://crempreendimentos-sc.com">
                        <span className="navbar-button" >
                            <span className="elementor-button-icon">
                                <FontAwesomeIcon icon={"user-alt"} />
                            </span>
                            <span className="elementor-button-text">CLIENTE</span>
                        </span>
                    </a>

                    <a href="https://crempreendimentos-sc.com/area-do-corretor/">
                        <span className="navbar-button">
                            <span className="elementor-button-icon">
                                <FontAwesomeIcon icon={"suitcase"} />
                            </span>
                            <span className="elementor-button-text">CORRETOR</span>
                        </span>
                    </a>
                </div>
            </div>
        </div>
    )
}